var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConnaitreJobstream"},[_c('HeadPage',{attrs:{"title":'JobStream',"category":'Nous connaitre',"img":'nous-connaitre/jobstream.jpg',"imgAlt":'Jobstream head page'}}),_c('ContentPage',{attrs:{"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }